import { render } from "./FiltersTab.vue?vue&type=template&id=337a2d6c&ts=true"
import script from "./FiltersTab.vue?vue&type=script&lang=ts"
export * from "./FiltersTab.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__